import {
  PromptsInChatService,
  PromptsInChatType,
} from 'src/app/shared/services/prompts-in-chat.service';
import {
  TermsModalComponent,
  TermsType,
} from '../../terms-modal/terms-modal.component';
import { TutorialService } from 'src/app/shared/services/communication_services/tutorial.service';
import { UserDataService } from 'src/app/shared/services/communication_services/userData.service';
import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';
import { BuildVersion } from 'src/environments/environment-model.interface';
import { NicknameService } from 'src/app/shared/services/nickname.service';
import { ModalsService } from 'src/app/shared/services/modals.service';
import { ChatType } from 'src/app/shared/types/chat-data.interface';
import { environment } from 'src/environments/environment';
import { ModalController, Platform } from '@ionic/angular';
import { NavHelper } from 'src/app/shared/helpers';
import { FormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ToastsService } from 'src/app/shared/services/toasts.service';
import {
  SplitTestCase,
  SplitTestCasesService,
} from 'src/app/shared/services/split-test-cases.service';
import { CreationGirlService } from 'src/app/shared/services/creation-girl.service';

interface Step {
  answers: { text: string; action: () => void }[];
}

@Component({
  selector: 'app-onboarding-modal',
  templateUrl: './onboarding-modal.component.html',
  styleUrls: ['./onboarding-modal.component.scss'],
  standalone: true,
  imports: [FormsModule],
})
export class OnboardingModalComponent implements OnInit {
  public readonly defaultNickname = 'Lover';
  public readonly environment = environment;
  public readonly buildVersion = BuildVersion;
  public inputField = '';
  public step = 0;

  public steps: Step[] = [
    // {
    //   answers: [
    //     {
    //       text: "It's okay, I don't mind at all 😉",
    //       action: () => {
    //         this.goToStep(1);
    //       },
    //     },
    //   ],
    // },
    {
      answers: [],
    },
    {
      answers: [
        {
          text: "I'm under 18",
          action: () => {
            const storeLink = this._platform.is('ios')
              ? 'https://apps.apple.com/cy/app/lovechats/id6444935703'
              : 'https://play.google.com/store/apps/details?id=app.perchapps.lovechats';

            this._analyticsService.ageIsSet(false);

            if (this._platform.is('ios')) {
              setTimeout(() => (location.href = storeLink), 1000);
            } else {
              this._toasts.showError('Sorry, this place is for adults only.');
            }
          },
        },
        {
          text: "I'm over 18",
          action: () => {
            this._promptsInChatService
              .setPrompt(PromptsInChatType.ageOver18)
              .subscribe();

            this.goToStep(2);
          },
        },
      ],
    },
    {
      answers: [
        {
          text: 'Yeah, it’s ok',
          action: () => {
            this._promptsInChatService
              .setPrompt(PromptsInChatType.agreement)
              .subscribe();
            // this.goToStep(3);
            this.goToChat();
          },
        },
      ],
    },
    {
      answers: [
        {
          text: "I'm very like to chat as well",
          action: () => {
            this.goToStep(4);
          },
        },
      ],
    },
    {
      answers: [
        {
          text: 'That is I love to hear!',
          action: () => {
            this.goToStep(5);
          },
        },
      ],
    },
    {
      answers: [
        {
          text: "I'm as ready as never 🍆💦",
          action: () => {
            this.goToChat();
          },
        },
      ],
    },
  ];

  constructor(
    private _promptsInChatService: PromptsInChatService,
    private _analyticsService: AnalyticsService,
    private _tutorialService: TutorialService,
    private _nicknameService: NicknameService,
    private _userDataService: UserDataService,
    private _modalController: ModalController,
    private _modalsService: ModalsService,
    private _navHelper: NavHelper,
    private _platform: Platform,
    private _toasts: ToastsService,
    private _splitTestCasesService: SplitTestCasesService,
    private _creationGirlService: CreationGirlService,
  ) {}

  public ngOnInit(): void {
    if (environment.variant === 'lovechatme') {
      this._promptsInChatService
        .setPrompt(PromptsInChatType.ageOver18)
        .subscribe();
    }
  }

  public submitNickname(event: Event) {
    event.preventDefault();

    this._nicknameService
      .set(
        this.inputField ? this.inputField : this.defaultNickname,
        !!this.inputField.length,
      )
      .subscribe();

    if (
      environment.buildVersion === BuildVersion.legal ||
      environment.variant === 'lovechatme'
    ) {
      this.goToStep(2);
    } else {
      this.goToStep(1);
    }
  }

  public goToStep(index: number) {
    switch (index) {
      case 0:
        this._tutorialService.setStep('enter_name');
        break;
      case 1:
        this._tutorialService.setStep('18_years');
        break;
      case 2:
        this._tutorialService.setStep('policy');
        break;
      case 3:
        this._tutorialService.setStep('my_girls');
        break;
      case 4:
        this._tutorialService.setStep('photos');
        break;
      case 5:
        this._tutorialService.setStep('tokens');
        break;
    }

    this.step = index;
  }

  public goToChat() {
    if (this._splitTestCasesService.hasCase(SplitTestCase.customAiTutorial)) {
      this._creationGirlService.tryOpenPopup();
      this._modalController.dismiss();
      this._tutorialService.setStep('create-girl');
    } else if (
      this._splitTestCasesService.hasCase(SplitTestCase.swipeTutorial)
    ) {
      this._tutorialService.setStep('first-swipe-visit');
      this._navHelper.goToCards();
      this._modalController.dismiss();
    } else {
      this._tutorialService.setStep('chat');
      const tutorialChat =
        this._userDataService.updateUserData.value.chats.find(
          (c) => c.type === ChatType.tutorial,
        );

      this._navHelper.goToChat(tutorialChat.id);
      this._modalController.dismiss();
    }
  }

  public openTermsModal(): void {
    this._modalsService
      .openModal(TermsModalComponent, {
        type: TermsType.termsOfUse,
      })
      .subscribe();
  }

  public openPrivacyModal(): void {
    this._modalsService
      .openModal(TermsModalComponent, {
        type: TermsType.privacy,
      })
      .subscribe();
  }

  public openCookiesModal(): void {
    this._modalsService
      .openModal(TermsModalComponent, {
        type: TermsType.cookies,
      })
      .subscribe();
  }

  public open18UscModal(): void {
    this._modalsService
      .openModal(TermsModalComponent, {
        type: TermsType.usc18,
      })
      .subscribe();
  }
}
